/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer1_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly closedAt: string | null;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_story" | "ReplyListContainer2_story">;
    readonly " $refType": "ReplyListContainer1_story";
};
export type ReplyListContainer1_story$data = ReplyListContainer1_story;
export type ReplyListContainer1_story$key = {
    readonly " $data"?: ReplyListContainer1_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer1_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closedAt",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "LiveConfiguration",
                    "kind": "LinkedField",
                    "name": "live",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enabled",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer2_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '8de95195d139b18cdd19f1b31048ffd0';
export default node;
